module.exports = __webpack_public_path__ + "img/Evaluation.9cf37fa5.png";